import { Component } from "react";

import { scrollToElement } from "../../../common/scroll";
import Loader from "../Loader";

window.reactSuspenseIsLoading = false;

class SuspenseLoader extends Component {
    render() {
        return <Loader />;
    }

    componentDidMount() {
        window.reactSuspenseIsLoading = true;
    }

    componentWillUnmount() {
        window.reactSuspenseIsLoading = false;
        const searchParams = new URL(document.location).searchParams;
        if (searchParams.get('scroll_to')) {
            scrollToElement(() => document?.getElementById(searchParams.get('scroll_to')), 1500);
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

}

export default SuspenseLoader;
